import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { addAnalytics } from '../../analytics/utils';
import { aiPanelsPluginKey } from './ai-panels-plugin-key';
import { getNewlyEditedAIPanels } from './utils';
export var createAIPanelsPlugin = function createAIPanelsPlugin() {
  return new SafePlugin({
    key: aiPanelsPluginKey,
    state: {
      init: function init(_, _state) {
        return {
          editedPanelIds: {}
        };
      },
      apply: function apply(tr, pluginState) {
        var meta = tr.getMeta(aiPanelsPluginKey);
        if (!meta || !meta.localIdsPanelTypes) {
          return pluginState;
        }
        var newEditedState = _objectSpread(_objectSpread({}, pluginState.editedPanelIds), meta.localIdsPanelTypes);
        return _objectSpread(_objectSpread({}, pluginState), {}, {
          editedPanelIds: newEditedState
        });
      }
    },
    appendTransaction: function appendTransaction(transactions, _oldState, newState) {
      var tr = newState.tr;
      var edited = false;
      var aiPluginState = aiPanelsPluginKey.getState(newState);
      var localIdsPanelTypes = getNewlyEditedAIPanels({
        transactions: transactions,
        knownEditedPanelIds: aiPluginState.editedPanelIds
      });
      if (Object.keys(localIdsPanelTypes).length) {
        tr = tr.setMeta(aiPanelsPluginKey, {
          localIdsPanelTypes: localIdsPanelTypes
        });
        edited = true;
        for (var _i = 0, _Object$entries = Object.entries(localIdsPanelTypes); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            _ = _Object$entries$_i[0],
            panelTypes = _Object$entries$_i[1];
          tr = addAnalytics({
            editorState: newState,
            tr: tr,
            payload: {
              action: 'edited',
              actionSubject: 'editorPluginAI',
              actionSubjectId: 'AIPanels',
              attributes: {
                extensionKey: panelTypes.extensionKey,
                extensionType: panelTypes.extensionType
              },
              eventType: EVENT_TYPE.UI
            }
          });
        }
      }
      return edited ? tr : null;
    }
  });
};